import React from "react";
import { useI18n } from "../lib/i18n.jsx";
import { Input } from "./ui/input";
import { iso, shift, daysBetween } from "./ReportFilters";

export const MAX_DAYS_3 = 3;
export const todayRange = () => ({ preset: "today", from: iso(new Date()), to: iso(new Date()) });
const range3 = (p) => p === "yesterday" ? [shift(-1), shift(-1)] : p === "3d" ? [shift(-2), shift(0)] : [shift(0), shift(0)];

export default function PeriodFilter({ period, setPeriod, testid = "period-filter" }) {
  const { t } = useI18n();
  const tooLong = daysBetween(period.from, period.to) > MAX_DAYS_3;
  const chip = (a) => `px-3 py-1.5 rounded-full text-sm font-semibold ${a ? "bg-[var(--sidebar)] text-white" : "tactical-card"}`;
  return (
    <div className="space-y-2 mb-3" data-testid={testid}>
      <div className="flex gap-2 flex-wrap items-center">
        <span className="text-xs uppercase font-semibold text-[var(--text-3)] mr-1">{t("period")}</span>
        {["today", "yesterday", "3d", "custom"].map((p) => (
          <button key={p} data-testid={`${testid}-${p}`} className={chip(period.preset === p)}
            onClick={() => { if (p === "custom") setPeriod({ ...period, preset: "custom" }); else { const [from, to] = range3(p); setPeriod({ preset: p, from, to }); } }}>
            {t(`period_${p}`)}
          </button>
        ))}
        {period.preset === "custom" && (<>
          <Input data-testid={`${testid}-from`} type="date" value={period.from} max={period.to} onChange={(e) => setPeriod({ ...period, from: e.target.value })} className="h-9 w-auto" />
          <Input data-testid={`${testid}-to`} type="date" value={period.to} min={period.from} onChange={(e) => setPeriod({ ...period, to: e.target.value })} className="h-9 w-auto" />
        </>)}
      </div>
      {tooLong && <div data-testid={`${testid}-too-long`} className="text-sm font-semibold text-[var(--red)]">{t("max_period_3d")}</div>}
    </div>
  );
}

export const periodOk = (period) => period.from && period.to && daysBetween(period.from, period.to) <= MAX_DAYS_3 && period.from <= period.to;
